<template>
  <div>
    <div class="mx-2">
      <v-switch dense v-model="groupBy" :label="groupByLabel"></v-switch>
    </div>
    <div>
      <v-expansion-panels accordion v-if="groupBy" v-model="localPanelIndex">
        <v-expansion-panel v-for="(point, index) in model.pointGroups" v-bind:key="index">
          <v-expansion-panel-header>{{ point.latitude }} {{ point.longitude }}</v-expansion-panel-header>
          <v-expansion-panel-content :eager="true">
            <v-row>
              <v-col>
                <v-btn @click="excelReport(point)">Excel</v-btn>
              </v-col>
            </v-row>
            <v-tabs background-color="red lighten-2" dark show-arrows>
              <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
              <v-tab v-for="(item, index) in predicts" v-bind:key="item.predict">
                <div v-bind:class="{ main_tab: predicts[index].main }">
                  <base-time-title v-model="predicts[index]" />
                </div>
              </v-tab>

              <v-tab-item v-for="item in point.predictGroups" v-bind:key="item.predict">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Тип уровня</th>
                        <th>Значение уровня</th>
                        <th>Короткое название</th>
                        <th>Название парметра</th>
                        <th>Ед. измерения</th>
                        <th>Значение</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in item.values" v-bind:key="data.code">
                        <th>{{ data.level_type }}</th>
                        <th>{{ data.level }}</th>
                        <th>{{ data.pname }}</th>
                        <td>{{ data.sname }}</td>
                        <td>{{ data.unit }}</td>
                        <td>{{ data.value }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs>
            <div>
              <forecast-chart :model="point" :parameters="model.parameters" :baseTime="baseTime" />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-expansion-panels accordion v-if="!groupBy">
        <v-expansion-panel v-for="(point, index) in model.pointGroups" v-bind:key="index">
          <v-expansion-panel-header>{{ point.latitude }} {{ point.longitude }}</v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <v-tabs background-color="red lighten-2" dark show-arrows>
              <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
              <v-tab v-for="item in model.parameters" v-bind:key="item.sname">{{ item.sname }}</v-tab>

              <v-tab-item v-for="item in point.parameterGroups" v-bind:key="item.code">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Заблаговременность</th>
                        <th>Значение</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in item.values" v-bind:key="data.code">
                        <th>{{ data.predict / 60 }}</th>
                        <th>{{ data.value }}</th>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs>
            <div>
              <forecast-chart :model="point" :parameters="model.parameters" :baseTime="baseTime" />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import ForecastChart from "./ForecastChart.vue";
import BaseTimeTitle from "../views/components/BaseTimeTitle.vue";
import formatPredict from "./format/formatPredict.js";
import PredictViewModel from "../components/viewmodels/PredictViewModel.js";

export default {
  name: "ForecastTabs",
  components: {
    ForecastChart,
    BaseTimeTitle
  },
  props: {
    model: Object,
    value: Number,
    userId: {
      type: String,
      default: null
    },
    baseTime: null
  },
  data: function() {
    return {
      groupBy: true,
      predicts: []
    };
  },
  methods: {
    async excelReport(point) {
      await this.$store.dispatch("SET_LOADING", true);
      const request = {
        lat: point.latitude,
        lon: point.longitude,
        userId: this.userId
      };

      await this.$store.dispatch("FORECAST_REPORT", request);
      await this.$store.dispatch("SET_LOADING", false);
    }
  },
  computed: {
    groupByLabel() {
      if (this.groupBy) return "Сгруппировать по заблаговременностям";
      return "Сгруппировать по параметрам";
    },
    localPanelIndex: {
      get() {
        return this.value;
      },
      set(localPanelIndex) {
        this.$emit("input", localPanelIndex);
      }
    }
  },
  watch: {
    model: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.predicts = newVal.predicts.map(x => {
            const result = new PredictViewModel();
            result.predict = x;
            const labels = formatPredict(x, this.baseTime);
            result.title = labels[0];
            result.subTitle = labels[1];
            result.main = labels[2];
            return result;
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.main_tab {
  border-left: 5px solid powderblue;
}
</style>
